import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  Form,
  LoadPanel,
  Popup,
  RequiredRule,
  Scrolling,
  SearchPanel,
  Selection,
  Texts,
  Toolbar,
} from "devextreme-react/data-grid";
import { Label, SimpleItem } from "devextreme-react/form";
import { Item } from "devextreme-react/toolbar";
import CustomStore from "devextreme/data/custom_store";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import OtherExperienceHtmlEditor from "./OtherExperienceHtmlEditor";

export default function OtherExperience() {
  const [dataSource, setDataSource] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);

  const otherExperienceGridRef = useRef(null);
  const otherExpereicneHtmlEditorRef = useRef(null);

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/cv/otherExperienceOrHistory/${userInfo.employeeNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/cv/otherExperienceOrHistory/${userInfo.employeeNo}`,
            {
              otrExpOrHis:
                otherExpereicneHtmlEditorRef.current.instance.option("value"),
            }
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/cv/otherExperienceOrHistory/${userInfo.employeeNo}/${key}`
          );
        },
      })
    );
  }, []);

  const onEditingStart = (e) => {
    e.component.selectRows(e.key, true);
  };

  const onSaving = React.useCallback(async (e) => {
    if (e.changes.length == 0) {
      const SEQ =
        otherExperienceGridRef.current.instance.option("editing.editRowKey");

      await axios.put(
        `${process.env.REACT_APP_BECCO_API_URL}/api/cv/otherExperienceOrHistory/${userInfo.employeeNo}/${SEQ}`,
        {
          otrExpOrHis:
            otherExpereicneHtmlEditorRef.current.instance.option("value"),
        }
      );

      otherExperienceGridRef.current.instance.refresh();
    }
  });

  const cellRender = (data) => {
    return <div dangerouslySetInnerHTML={{ __html: data.data.otrExpOrHis }} />;
  };

  const onHiding = (e) => {
    otherExperienceGridRef.current.instance.deselectAll();
  };

  return (
    <DataGrid
      id="careerHistoryGrid"
      ref={otherExperienceGridRef}
      dataSource={dataSource}
      rowAlternationEnabled={true}
      showBorders={true}
      showColumnLines={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      allowColumnReordering={true}
      style={{
        maxHeight: "calc(100vh - 180px)",
        marginLeft: "10px",
        marginRight: "10px",
        // marginTop: "56px",
      }}
      hoverStateEnabled={true}
      showColumnHeaders={false}
      onEditingStart={onEditingStart}
      onSaving={onSaving}
    >
      <LoadPanel enabled={true} />
      <SearchPanel visible={true} />

      <Scrolling mode={"virtual"} showScrollbar={"always"} />
      <Selection mode={"single"} />

      <Editing
        mode={"popup"}
        allowAdding={true}
        allowDeleting={true}
        allowUpdating={true}
      >
        <Texts
          confirmDeleteTitle={"Delete the Other Experience or History"}
          confirmDeleteMessage={
            "Are you sure you want to delete this experience or history?"
          }
        />
        <Popup
          title={"Other Experience or History"}
          showTitle={true}
          height={600}
          onHiding={onHiding}
        />
        <Form
          labelMode={"outside"}
          showColonAfterLabel={false}
          labelLocation="top"
          minColWidth={300}
          colCount={2}
          colCountByScreen={{ sm: 2, md: 4 }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="careerHistory"
          height={"100%"}
        >
          <SimpleItem dataField={"otrExpOrHis"} colSpan={4}>
            <Label text={"Other Experience or History"} />
            <RequiredRule
              message={"* Other Expereience or History를 입력해주세요."}
            />
            <OtherExperienceHtmlEditor
              otherExperienceGridRef={otherExperienceGridRef}
              otherExpereicneHtmlEditorRef={otherExpereicneHtmlEditorRef}
            />
          </SimpleItem>
        </Form>
      </Editing>

      <Column
        dataField={"otrExpOrHis"}
        caption="Other Experience Or History"
        cellRender={cellRender}
      />

      <Toolbar>
        <Item location={"before"}>
          <span
            style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
          >
            OTHER EXPERIENCE OR HISTORY
          </span>
        </Item>
        <Item location={"after"} name="addRowButton" />
        <Item location={"after"} name="searchPanel" />
      </Toolbar>
    </DataGrid>
  );
}
